import { DhlServicePoint } from 'skladon-types';
import { OptionType } from 'src/components/Select';

export const formatData = (data: DhlServicePoint[]): OptionType[] => {
    return data.map((item) => ({
        label: `${item.name} — ${item.street}, ${item.city}, ${item.postalCode} (${item.servicePointId})`,
        value: item.servicePointId,
    }));
};
